import { all, apply, put, takeLatest } from 'redux-saga/effects'
import { IAxiosResponse } from '../root.types'
import { RelevanceTypes } from './types'
import {  loadRelevanceFailure,  loadRelevanceSuccess} from './actions'
import relevanceService from '../../../services/relevance'
import { Map } from '../../application/models/map/map'


export function* loadRelevance() {

    try {
        const response: IAxiosResponse<Map[]> = yield apply(
            relevanceService,
            relevanceService.getAll,
            []
        )

        yield put<any>(loadRelevanceSuccess(response))
    } catch (e) {
        yield put<any>(loadRelevanceFailure())
    }

}

export default function* relevanceSaga() {
    return yield all([
        takeLatest(RelevanceTypes.LOAD_RELEVANCE_REQUEST, loadRelevance),
    ])
}